export default "__VITE_ASSET__hqV5fNrA__"